import React, { Fragment, useEffect, useState } from 'react';
import Breadcrumb from '../../../layout/breadcrumb'
import { Container, Row, Col, Card, CardHeader, CardBody, Table, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, Button, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { createClient } from "@supabase/supabase-js";
import { Accordion } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();

const Vehicle = (props) => {
  const LargeModaltoggle = () => {
    setname("")

    setmobilenumber("")

    setemail("")

    setvehicletype("")
    setvehiclenumber("")
    setvehiclebodyweight("")
    setvehicletonnage("")



    setaadharno("")
    setdob("")







    setLarge(!Large)
  };
  const [edittype, setedittype] = useState("")
  const [editid, seteditid] = useState("")
  const [Large, setLarge] = useState(false);
  const [name, setname] = useState('')
  const [email, setemail] = useState('')
  const [mobilenumber, setmobilenumber] = useState('')

  const [aadharno, setaadharno] = useState('')
  const [dob, setdob] = useState('')
  const [vehicletype, setvehicletype] = useState('')
  const [vehiclenumber, setvehiclenumber] = useState('')
  const [vehiclebodyweight, setvehiclebodyweight] = useState("")
  const [vehicletonnage, setvehicletonnage] = useState("")


  const [vehicle_detail, setvehicle_detail] = useState([])

  const [vehicle_type, setvehicle_type] = useState([])
  const [clientHeight, setclientHeight] = useState("")

  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

  const supabase = createClient(supabaseUrl, supabaseKey);
  useEffect(() => {

    
    if(localStorage.getItem("usertype")!="Supplier"){
      window.history.back()
    }

    getvehicletype()







    


    getvehicledetail()
  }, [])
  async function getvehicletype(){
    let { data: vehicle_type, error3 } = await supabase
      .from('vehicle_type_details')
      .select('*')
    if (error3 === undefined) {
      setvehicle_type(vehicle_type)
    }
  }

  async function getvehicledetail() {
    let { data: vehicle_details, error } = await supabase
      .from('vehicle_details')
      .select('*')
      .eq("createdBy", localStorage.getItem("useremail"))

    if (vehicle_details !== null && vehicle_details.length > 0) {
      setvehicle_detail(vehicle_details)
      setTimeout(() => {
        setclientHeight(window.innerHeight * 0.71)

      }, 1000)
    } else {
      // toast.error("No vehicle Details Found")
      setvehicle_detail([])
    }
  }

  const randomUsername = () => {
    return `${Date.now().toString().substr(-4)}`;
  };
  const UpdateUser = async (vehicleid) => {
    setLarge(!Large)
    setedittype("updated")
    seteditid(vehicleid)
    let { data: vehicle_details, error } = await supabase
      .from('vehicle_details')
      .select('*')
      .eq('vehicle_id', vehicleid)

    if (vehicle_details !== null && vehicle_details.length > 0) {
      setname(vehicle_details[0].vehicle_owner_name)
      setmobilenumber(vehicle_details[0].vehicle_owner_number.toString().slice(2, 12))
      setemail(vehicle_details[0].vehicle_owner_email)



      if (vehicle_details[0].vehicle_owner_aadharno === null) {
        setaadharno("")
      } else {
        setaadharno(vehicle_details[0].vehicle_owner_aadharno)
      }
      if (vehicle_details[0].vehicle_owner_dob === "") {
        setdob("")
      } else {
        setdob(vehicle_details[0].vehicle_owner_dob)
      }
      setvehiclenumber(vehicle_details[0].vehicle_number)
      setvehicletype(vehicle_details[0].vehicle_type)
      setvehiclebodyweight(vehicle_details[0].vehicle_bodyweight)
      setvehicletonnage(vehicle_details[0].vehicle_tonnage)
    }
  }
  const DeleteUser = async (vehicleid) => {
    let { data: user_Details, error1 } = await supabase
      .from('User_Details')
      .delete()
      .eq('user_id', vehicleid)
    console.log(user_Details, error1)
    if (user_Details !== null && user_Details.length > 0) {
      let { data: vehicle_details, error } = await supabase
        .from('vehicle_details')
        .delete()
        .eq('vehicle_id', vehicleid)
      console.log(vehicle_details, error)
      if (vehicle_details !== null && vehicle_details.length > 0) {

        toast.success("Vehicle Deleted Successfully")
        getvehicledetail()


      } else {
        toast.error("Error in Deleting vehicle")
      }
    } else {
      toast.error("Error in Deleting vehicle")
    }
  }
  const validatevehicleno = (vehicleno) => {
    var vehreg = /^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/
    if (vehicleno.length == 10 || vehicleno.length == 9) {
      return true
    } else {
      return false
    }
  }
  const validateaadharno = (aadharno) => {
    var reg = /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/;
    if (reg.test(aadharno)) {
      return true;
    } else {
      return false;
    }

  }

  const validateemail = (email) => {
    const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    if (re.test(email)) {
      return true
    } else {
      return false
    }
  }
  const RegisterUser = async (type, id) => {

    if (name === "") {
      toast.error("Please Enter Name")
    } else if (email === "") {
      toast.error("Please Enter Email")
    } else if (!validateemail(email)) {
      toast.error("Please Enter Valid Email")
    } else if (mobilenumber === "") {
      toast.error("Please Enter Mobile Number")
    } else if (mobilenumber.length !== 10) {
      toast.error("Please Enter Valid Mobile Number")
    } else if (vehiclenumber === "") {
      toast.error("Please Enter Vehicle Number")
    } else if (!validatevehicleno(vehiclenumber)) {
      toast.error("Please Enter Valid Vehicle Number")
    } else if (vehicletype === "") {
      toast.error("Please Select Vehicle Type")
    } else if (vehiclebodyweight === "") {
      toast.error("Please Enter Vehicle Body Weight")
    } else if (vehicletonnage === "") {
      toast.error("Please Enter Vehicle Tonnage")
    } else if (aadharno === "") {
      toast.error("Please Enter Aadhar Number")
    } else if (!validateaadharno(aadharno)) {
      toast.error("Please Enter Valid Aadhar Number")
    } else if (dob === "") {
      toast.error("Please Enter Date of Birth")
    } else {
      if (type === "new") {
        var vehicle_id = `vehicle${randomUsername()}`
        const { data: user, error1 } = await supabase
          .from('User_Details')
          .insert([
            { user_id: vehicle_id, user_name: name, user_type: "Vehicle Owner", user_phone: parseInt("91" + mobilenumber), user_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/vehicle/profile.jpg", user_email: email, user_aadhar_no: aadharno, user_dob: dob },
          ])

        if (user !== null) {
          const { data, error } = await supabase
            .from('vehicle_details')
            .insert([
              { vehicle_id: vehicle_id, createdBy: window.localStorage.getItem("useremail"), vehicle_owner_email: email, vehicle_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/vehicle/profile.jpg", vehicle_owner_name: name, vehicle_owner_number: parseInt("91" + mobilenumber), vehicle_owner_dob: dob, vehicle_owner_aadharno: parseInt(aadharno), vehicle_number: vehiclenumber, vehicle_type: vehicletype, vehicle_tonnage: vehicletonnage, vehicle_bodyweight: vehiclebodyweight },
            ])

          if (data !== null) {


            toast.success(`Vehicle Created Successfully`)
            setLarge(!Large)
            getvehicledetail()


          } else {
            toast.error(error.message)
          }
        } else {
          toast.error("Error in Creating Vehicle")
        }
      } else {
        vehicle_id = id
        const { data: user, error1 } = await supabase
          .from('User_Details')
          .update(
            { user_name: name, user_type: "Vehicle Owner", user_phone: parseInt("91" + mobilenumber), user_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/vehicle/profile.jpg", user_email: email, user_aadhar_no: aadharno, user_dob: dob },
          )
          .eq('user_id', vehicle_id)

        if (user !== null) {
          const { data, error } = await supabase
            .from('vehicle_details')
            .update(
              { vehicle_owner_email: email, createdBy: window.localStorage.getItem("useremail"), vehicle_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/vehicle/profile.jpg", vehicle_owner_name: name, vehicle_owner_number: parseInt("91" + mobilenumber), vehicle_owner_dob: dob, vehicle_owner_aadharno: parseInt(aadharno), vehicle_number: vehiclenumber, vehicle_type: vehicletype, vehicle_tonnage: vehicletonnage, vehicle_bodyweight: vehiclebodyweight },
            )
            .eq('vehicle_id', vehicle_id)

          if (data !== null) {


            toast.success(`Vehicle Updated Successfully`)
            setLarge(!Large)
            getvehicledetail()


          } else {
            toast.error(error.message)
          }
        } else {
          toast.error("Error in Updating Vehicle")
        }
      }
    }



  }
  return (
    <Fragment>
      <Breadcrumb parent="Dashboard" title="vehicle Details" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">

                <Modal isOpen={Large} toggle={LargeModaltoggle} size="lg" centered>
                  <ModalHeader toggle={LargeModaltoggle}>
                    {edittype === "new" ? "Register" : "Update"} Here For  Vehicle
                  </ModalHeader>
                  <ModalBody>
                    <Row>
                      <Col>

                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Name<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="text" placeholder="Enter Your Name" value={name} onChange={(e) => { setname(e.target.value) }} />
                          </Col>
                        </FormGroup>

                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText><Icon icon="twemoji:flag-india" width="25" height="25" /></InputGroupText>
                              </InputGroupAddon>
                              <Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} />
                            </InputGroup>
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label"> Email<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} />
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label"> Aadhar No<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="number" placeholder='Enter Your Aadhar No' value={aadharno} onChange={(e) => { setaadharno(e.target.value) }} />
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label"> Date Of Birth<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="date" placeholder='Enter Your Date of Birth' value={dob} onChange={(e) => { setdob(e.target.value) }} />
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Vehicle Type<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="select" value={vehicletype} onChange={(e) => { setvehicletype(e.target.value) }}>
                              <option value={""}>Choose Your Vehicle Type</option>
                              {vehicle_type.map((data, i) => {

                                return (
                                  <option key={i} value={data.vehicle_type}>{data.vehicle_type}</option>
                                )
                              })}
                            </Input>

                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Vehicle No<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="text" placeholder="Enter Your Vehicle No" value={vehiclenumber} onChange={(e) => {
                              setvehiclenumber(e.target.value)
                            }} />
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Vehicle Tonnage<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="text" placeholder="Enter Vehicle Tonnage" value={vehicletonnage} onChange={(e) => {
                              setvehicletonnage(e.target.value)
                            }} />
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Vehicle BodyWeight<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="number" placeholder="Enter Vehicle BodyWeight" value={vehiclebodyweight} onChange={(e) => {
                              setvehiclebodyweight(e.target.value)
                            }} />
                          </Col>
                        </FormGroup>
                        <FormGroup className="mb-0 mt-3">


                          <Button color="primary" className="btn-block" onClick={() => {
                            RegisterUser(edittype, editid)
                          }}>PROCEED </Button>
                        </FormGroup>





                      </Col>
                    </Row>
                  </ModalBody>
                </Modal>
                {window.innerWidth < 800 ? <>
              <div style={{ textAlign: "right",padding:"5px" }}>
                <button className='btn' style={{ fontSize: "13px", padding: "10px", boxShadow: "0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)", borderRadius: "10px", backgroundColor: "#E50014", color: "white" }} onClick={() => {
                  LargeModaltoggle(); setedittype("new")
                  seteditid("")
                }}>Create Vehicle</button>
              </div>

              <div style={clientHeight !== "" ? { height: clientHeight + "px", overflowY: "scroll", padding: "5px" } : { height: "100%" }}>
                <Accordion>

                  <div className="default-according" id="accordionclose">

                    {vehicle_detail.length > 0 ? <>
                      {vehicle_detail.map((data, i) => {
                        return (
                          <Card key={i} style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: "10px" }}>
                            <CardHeader onClick={() => { document.getElementById(`one${i + 1}`).click() }} style={{ cursor: "pointer", borderRadius: "10px" }}>
                              <h5 className="mb-0" style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                              }}>
                                <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" eventKey={i + 1} id={"one" + (i + 1)} style={{ padding: "0px" }}>
                                  <div className="email-app-sidebar left-bookmark">
                                    <div className="media" style={{ alignItems: "center " }}>
                                      <div className="media-size-email"><img src={data.vehicle_pic} alt="buyer_image" height={"40px"} width={"40px"} style={{ borderRadius: "10px" }} />
                                      </div>
                                      <div className="media-body" style={{ textAlign: "left", marginLeft: "20px" }}>

                                        <span style={{ display: "block" }}>{data.vehicle_number}</span>
                                        <span style={{ display: "block" }}>{data.vehicle_type}</span>

                                      </div>


                                    </div>
                                  </div>



                                </Accordion.Toggle>
                                <div className="media-size-email" style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "row",
                                }}> <div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#dfffe4", padding: "5px", cursor: "pointer" }} onClick={() => {
                                  UpdateUser(data.vehicle_id)
                                }}><Icon icon="bxs:edit" color="darkgreen" width="30" height="30" /></div>
                                  &nbsp;
                                  <div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#efc6ca", padding: "5px", cursor: "pointer" }} onClick={() => {
                                    DeleteUser(data.vehicle_id)
                                  }}><Icon icon="bi:trash" color="#E50014" width="25" height="25" /></div>



                                </div>
                              </h5>
                            </CardHeader>
                            <Accordion.Collapse eventKey={i + 1} style={{ borderRadius: "10px" }}>
                              <CardBody>
                                <div className="email-app-sidebar left-bookmark">
                                  <div className="media" >

                                    <div className="media-body" style={{ textAlign: "left" }}>
                                    <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}> Name</span>
                                      <span style={{ display: "block" }}>{data.vehicle_owner_name}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}> Phone</span>
                                      <span style={{ display: "block" }}>{data.vehicle_owner_number.toString().slice(2, 12)}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}> Email</span>
                                      <span style={{ display: "block" }}>{data.vehicle_owner_email}</span>
                                      


                                    </div>
                                    <div className="media-body" style={{ textAlign: "left" }}>
                                      
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Tonnage</span>
                                      <span style={{ display: "block" }}>{data.vehicle_tonnage}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>BodyWeight</span>
                                      <span style={{ display: "block" }}>{data.vehicle_bodyweight}</span>


                                    </div>


                                  </div>


                                </div>


                              </CardBody>
                            </Accordion.Collapse>
                          </Card>
                        )


                      })}</> : <Card>
                      <CardHeader >
                        <h5 className="mb-0">
                          <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" >
                            No Record Found
                          </Accordion.Toggle>
                        </h5>
                      </CardHeader>
                    </Card>}
                  </div>

                </Accordion>
              </div></> :
            <Card>
              <CardHeader>
                <button className='btn btn-primary' style={{ float: "right" }} onClick={() => {
                  LargeModaltoggle(); setedittype("new")
                  seteditid("")
                }}>Create Vehicle</button>
              </CardHeader>
              <CardBody>
                <div className="table-responsive ">
                  <Table>
                    <thead>
                      <tr style={{textAlign:"center"}}>
                        <th scope="col">{"Sr.No"}</th>
                        <th scope="col">{"Vehicle Image"}</th>
                        <th scope="col">{"Vehicle No"}</th>
                        <th scope="col">{"Vehicle Owner Name"}</th>
                        <th scope="col">{"Vehicle Owner Email"}</th>
                        <th scope="col">{"Vehicle Owner Phone"}</th>
                        <th scope="col">{"Vehicle Type"}</th>
                        <th scope="col">{"Vehicle Tonnage"}</th>
                        <th scope="col">{"Vehicle BodyWeight"}</th>
                        {/* <th scope="col">{"Vehicle Owner Aadhar No"}</th>
                      <th scope="col">{"Vehicle Owner DOB"}</th> */}
                        <th scope="col">{"Action"}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {vehicle_detail.length > 0 ? <>
                        {vehicle_detail.map((data, i) => {
                          return (
                            <tr key={i} style={{textAlign:"center"}}>
                              <th scope="row">{i + 1}</th>
                              <td><img src={data.vehicle_pic} alt="vehicle_image" height={"40px"} width={"40px"} style={{ borderRadius: "10px" }} /></td>
                              <td><div style={{ backgroundColor: "#ffdd00", fontWeight: "500", padding: "5px", borderRadius: "5px", textAlign: "center" }}><div style={{ fontWeight: "400" }}>{data.vehicle_number.substring(0, 6)}</div><div style={{ fontWeight: "700",fontSize:"19px" }}>{data.vehicle_number.substring(6, 10)}</div></div></td>
                              <td>{data.vehicle_owner_name}</td>
                              <td>{data.vehicle_owner_email}</td>
                              <td>{data.vehicle_owner_number.toString().slice(2,12)}</td>
                              <td>{data.vehicle_type}</td>
                             
                             
                              <td>{data.vehicle_tonnage}</td>
                              <td>{data.vehicle_bodyweight}</td>
                              {/* <td>{data.vehicle_owner_aadharno}</td>
                            <td>{data.vehicle_owner_dob}</td> */}
                              <td><button className='btn btn-warning' onClick={() => {
                                UpdateUser(data.vehicle_id)
                              }}><i className='fa fa-edit '></i></button> &nbsp;<button className='btn btn-danger' onClick={() => {
                                DeleteUser(data.vehicle_id)
                              }}><i className='fa fa-trash'></i></button></td>
                            </tr>
                          )
                        })}
                      </>
                        : <tr style={{textAlign:"center"}}><td colSpan="12" style={{ textAlign: "center" }}>No Record Found</td></tr>}


                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>}

          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}

export default Vehicle;